import type {
  Product as IProduct,
  ProductConnection,
} from "@shopify/hydrogen/storefront-api-types";
import { ProductSearch } from "@components/molecules/product/product-search";
import { ProductMobile } from "@components/molecules/product/product-mobile";
import ViewOnlyProduct from "@components/molecules/product/viewOnlyProduct";
import { Product } from "@components/molecules/product/index";

export enum ProductType {
  Default,
  ViewOnly,
  Mobile,
  Search,
}

interface Props {
  products: ProductConnection["nodes"];
  productType?: ProductType;
  onRedirect?: () => void;
  className?: string;
}

const productComponents = {
  [ProductType.Default]: (product: IProduct, onRedirect?: () => void) => (
    <Product key={product.id} product={product} onRedirect={onRedirect} />
  ),
  [ProductType.ViewOnly]: (product: IProduct, onRedirect?: () => void) => (
    <ViewOnlyProduct
      key={product.id}
      product={product}
      onRedirect={onRedirect}
    />
  ),
  [ProductType.Mobile]: (product: IProduct, onRedirect?: () => void) => (
    <ProductMobile key={product.id} product={product} onRedirect={onRedirect} />
  ),
  [ProductType.Search]: (product: IProduct, onRedirect?: () => void) => (
    <ProductSearch key={product.id} product={product} onRedirect={onRedirect} />
  ),
};

export function ProductGrid(props: Props) {
  const {
    products,
    productType = ProductType.Default,
    className,
    onRedirect,
  } = props;

  return (
    <div className={`flex flex-wrap gap-5 m-5 ${className}`}>
      {products.map((product: IProduct) => {
        return productComponents[productType](product, onRedirect);
      })}
    </div>
  );
}
